/* eslint-disable */
import React from "react";
import { Card, Title, Divider, Text, List } from "@mantine/core";

export default function LocationAccessCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Location Access Disclosure</Title>
      <Divider my="md" />
      <Text>
        Our app accesses your location (including in the background) only for
        the following purposes:
      </Text>
      <List spacing="xs" mt="sm">
        <List.Item>
          To provide accurate local weather updates based on your location.
        </List.Item>
        <List.Item>
          To enable the SOS feature, which uses your location to send emergency
          alerts with coordinates.
        </List.Item>
      </List>
      <Text mt="sm">
        We do <strong>not</strong> use your location for advertising, tracking,
        or unrelated purposes.
      </Text>
    </Card>
  );
}
